import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_10 = {
  key: 1,
  class: "w-full"
}
const _hoisted_11 = {
  key: 0,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "noScrollbar tabControlMapping businesssPopup"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 2,
  class: "noScrollbar tabControl"
}
const _hoisted_16 = { class: "statuscontainer" }
const _hoisted_17 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_18 = { class: "row flex flex-row w-full" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = { class: "text-sm mt-2 mb-3" }
const _hoisted_21 = { class: "w-6/12 leftspacing" }
const _hoisted_22 = { class: "text-sm mt-2 mb-3" }
const _hoisted_23 = { class: "row flex flex-row w-full" }
const _hoisted_24 = { class: "w-6/12" }
const _hoisted_25 = { class: "text-sm mt-2 mb-3" }
const _hoisted_26 = { class: "w-6/12 leftspacing" }
const _hoisted_27 = { class: "text-sm mt-2 mb-3" }
const _hoisted_28 = { class: "row flex flex-row w-full" }
const _hoisted_29 = { class: "w-6/12" }
const _hoisted_30 = { class: "text-sm mt-2 mb-3" }
const _hoisted_31 = { class: "w-6/12 leftspacing" }
const _hoisted_32 = { class: "row flex flex-row w-full" }
const _hoisted_33 = { class: "w-full" }
const _hoisted_34 = { class: "text-sm mt-2 mb-3" }
const _hoisted_35 = {
  key: 3,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_36 = {
  key: 0,
  class: "tableCornerRadius"
}
const _hoisted_37 = { class: "table-container" }
const _hoisted_38 = {
  class: "header cursor-pointer",
  style: {"width":"5%"}
}
const _hoisted_39 = { class: "flex items-center w-4" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["value"]
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = ["value"]
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["value"]
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "cursor-pointer rowHeight" }
const _hoisted_52 = ["colspan"]
const _hoisted_53 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["value"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  class: "relative flex regular justify-center",
  style: {"width":"85%"}
}
const _hoisted_58 = ["onMousemove"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = ["onMousemove"]
const _hoisted_62 = { class: "table-ellipsis" }
const _hoisted_63 = ["onMousemove"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_67 = { class: "flex flex-col h-full" }
const _hoisted_68 = { class: "flex-1 overflow-auto" }
const _hoisted_69 = { class: "popup-business" }
const _hoisted_70 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_71 = { class: "formcontainer flex flex-col" }
const _hoisted_72 = { class: "row flex flex-row w-full pt-4" }
const _hoisted_73 = { class: "w-full" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_76 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_77 = { key: 1 }
const _hoisted_78 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_79 = { class: "row flex flex-row w-full pt-4" }
const _hoisted_80 = { class: "w-3/6" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_83 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_84 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_85 = { class: "w-3/6 leftspacing" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_88 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_89 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_90 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_91 = { class: "w-full" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_94 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_95 = { key: 1 }
const _hoisted_96 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_97 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_98 = { class: "w-3/6" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_101 = { class: "w-3/6 leftspacing" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_104 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_105 = { class: "w-full" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_108 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_109 = { key: 1 }
const _hoisted_110 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_111 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_112 = { class: "w-full" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_115 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_116 = { key: 1 }
const _hoisted_117 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_118 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_119 = { class: "w-6/12" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_122 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_123 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_124 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_125 = { class: "w-6/12 leftspacing" }
const _hoisted_126 = { key: 0 }
const _hoisted_127 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_128 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_129 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_130 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_131 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_132 = { class: "w-6/12" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_135 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_136 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_137 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_138 = { class: "w-6/12 leftspacing" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_141 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_142 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_143 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_144 = { class: "w-6/12 upperspacing" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_147 = { class: "row flex flex-row w-full" }
const _hoisted_148 = { class: "w-6/12 upperspacing" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_151 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_152 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_153 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { class: "w-6/12 upperspacing" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_158 = ["disabled"]
const _hoisted_159 = ["disabled"]
const _hoisted_160 = ["disabled"]
const _hoisted_161 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_162 = { class: "flex flex-col h-full" }
const _hoisted_163 = { class: "flex-1 overflow-auto" }
const _hoisted_164 = { class: "popup-business" }
const _hoisted_165 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_166 = { class: "formcontainer flex flex-col" }
const _hoisted_167 = { class: "w-full upperspacing" }
const _hoisted_168 = { class: "text-sm" }
const _hoisted_169 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_170 = { class: "row flex flex-row w-full" }
const _hoisted_171 = { class: "w-6/12" }
const _hoisted_172 = { class: "text-sm" }
const _hoisted_173 = { class: "w-3/6 leftspacing" }
const _hoisted_174 = { class: "text-sm" }
const _hoisted_175 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_176 = { class: "w-full" }
const _hoisted_177 = { class: "text-sm" }
const _hoisted_178 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_179 = { class: "row flex flex-row w-full" }
const _hoisted_180 = { class: "w-6/12" }
const _hoisted_181 = { class: "text-sm" }
const _hoisted_182 = { class: "w-6/12 leftspacing" }
const _hoisted_183 = { class: "text-sm" }
const _hoisted_184 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_185 = { class: "w-full" }
const _hoisted_186 = { class: "text-sm" }
const _hoisted_187 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_188 = { class: "row flex flex-row w-full" }
const _hoisted_189 = { class: "w-6/12" }
const _hoisted_190 = { class: "text-sm" }
const _hoisted_191 = { class: "w-6/12 leftspacing" }
const _hoisted_192 = { class: "text-sm" }
const _hoisted_193 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_194 = { class: "row flex flex-row w-full" }
const _hoisted_195 = { class: "w-6/12" }
const _hoisted_196 = { class: "text-sm" }
const _hoisted_197 = { class: "w-6/12 leftspacing" }
const _hoisted_198 = { class: "text-sm" }
const _hoisted_199 = { class: "formcontainer" }
const _hoisted_200 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_201 = { class: "w-3/6" }
const _hoisted_202 = { class: "text-sm" }
const _hoisted_203 = { class: "w-3/6 leftspacing" }
const _hoisted_204 = { class: "text-sm" }
const _hoisted_205 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_206 = ["disabled"]
const _hoisted_207 = { class: "flex-1 overflow-auto" }
const _hoisted_208 = { class: "popup-business" }
const _hoisted_209 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_210 = { class: "formcontainer flex flex-col" }
const _hoisted_211 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_212 = {
  key: 0,
  class: "w-full"
}
const _hoisted_213 = { class: "text-sm" }
const _hoisted_214 = {
  key: 1,
  class: "w-full"
}
const _hoisted_215 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_216 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_217 = {
  key: 0,
  class: "w-full upperspacing"
}
const _hoisted_218 = { class: "text-sm" }
const _hoisted_219 = {
  key: 1,
  class: "w-full upperspacing"
}
const _hoisted_220 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_221 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_222 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_223 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_224 = { class: "text-sm" }
const _hoisted_225 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_226 = { key: 0 }
const _hoisted_227 = { class: "text-sm" }
const _hoisted_228 = {
  key: 3,
  class: "w-6/12 leftspacing"
}
const _hoisted_229 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_230 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_231 = { key: 0 }
const _hoisted_232 = { class: "text-sm" }
const _hoisted_233 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_234 = { key: 0 }
const _hoisted_235 = { class: "text-sm" }
const _hoisted_236 = {
  key: 3,
  class: "w-6/12 leftspacing"
}
const _hoisted_237 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_238 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_239 = { key: 0 }
const _hoisted_240 = { class: "text-sm" }
const _hoisted_241 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_242 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_243 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_244 = {
  key: 2,
  class: "w-6/12"
}
const _hoisted_245 = { key: 0 }
const _hoisted_246 = { class: "text-sm" }
const _hoisted_247 = {
  key: 0,
  class: "border-b border-solid border-lightgrey"
}
const _hoisted_248 = {
  key: 0,
  class: "statuscontainer p-2 w-11/12 my-2 border-solid border border-lightgrey rounded"
}
const _hoisted_249 = { class: "text-sm font-light text-gray bg-white" }
const _hoisted_250 = { class: "text-sm flex flex-row items-center justify-between" }
const _hoisted_251 = { class: "flex justify-center items-center" }
const _hoisted_252 = ["onClick"]
const _hoisted_253 = { key: 0 }
const _hoisted_254 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_255 = { key: 1 }
const _hoisted_256 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_257 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_258 = { class: "flex flex-col h-full" }
const _hoisted_259 = { class: "flex-1 overflow-auto" }
const _hoisted_260 = { class: "popup-priority" }
const _hoisted_261 = { class: "w-full popupbodycontainer" }
const _hoisted_262 = { class: "w-full upperspacing" }
const _hoisted_263 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_264 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_265 = { class: "w-1/2 upperspacing" }
const _hoisted_266 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_267 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_268 = { key: 1 }
const _hoisted_269 = { class: "row flex flex-row w-full" }
const _hoisted_270 = { class: "w-full upperspacing" }
const _hoisted_271 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_272 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_273 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_274 = ["disabled"]
const _hoisted_275 = ["disabled"]
const _hoisted_276 = { class: "flex flex-col h-full" }
const _hoisted_277 = { class: "flex-1 overflow-auto" }
const _hoisted_278 = { class: "border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen" }
const _hoisted_279 = { class: "flex items-center justify-between p-3 rounded popupheadingcontainer" }
const _hoisted_280 = { key: 0 }
const _hoisted_281 = { key: 1 }
const _hoisted_282 = { key: 2 }
const _hoisted_283 = { key: 3 }
const _hoisted_284 = { key: 4 }
const _hoisted_285 = { key: 5 }
const _hoisted_286 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_287 = { class: "formcontainer flex flex-col" }
const _hoisted_288 = { class: "row flex flex-col" }
const _hoisted_289 = { class: "upperspacing" }
const _hoisted_290 = { class: "text-xs flex flex-wrap" }
const _hoisted_291 = { key: 0 }
const _hoisted_292 = { class: "w-full upperspacing" }
const _hoisted_293 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_294 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_295 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_296 = {
  key: 3,
  class: "controllabel"
}
const _hoisted_297 = {
  key: 4,
  class: "controllabel"
}
const _hoisted_298 = {
  key: 5,
  class: "controllabel"
}
const _hoisted_299 = {
  key: 6,
  class: "text-red-500"
}
const _hoisted_300 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_301 = { key: 0 }
const _hoisted_302 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_303 = { class: "col-md-6 w-6/12" }
const _hoisted_304 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_305 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_306 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_307 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_308 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_309 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_310 = { class: "col-md-6 w-6/12" }
const _hoisted_311 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_312 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_313 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_314 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_315 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_316 = { class: "w-6/12 upperspacing" }
const _hoisted_317 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_318 = { class: "w-6/12" }
const _hoisted_319 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_320 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_321 = { class: "w-6/12 upperspacing" }
const _hoisted_322 = { key: 1 }
const _hoisted_323 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_324 = { class: "col-md-6 w-6/12" }
const _hoisted_325 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_326 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_327 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_328 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_329 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_330 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_331 = { class: "col-md-6 w-6/12" }
const _hoisted_332 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_333 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_334 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_335 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_336 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_337 = { class: "w-6/12 upperspacing" }
const _hoisted_338 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_339 = { class: "w-6/12" }
const _hoisted_340 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_341 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_342 = { class: "w-6/12 upperspacing" }
const _hoisted_343 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_344 = ["disabled"]
const _hoisted_345 = ["disabled"]
const _hoisted_346 = ["disabled"]
const _hoisted_347 = ["disabled"]
const _hoisted_348 = ["disabled"]
const _hoisted_349 = ["disabled"]
const _hoisted_350 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.businessProcess.businessProcessName), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedTabIndex == 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btnprimary flex items-center",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRiskForProcess && _ctx.addRiskForProcess(...args)))
            }, "Add"))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btnprimary flex items-center",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addInformationForProcess && _ctx.addInformationForProcess(...args)))
            }, "Add"))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: _normalizeClass(["flex items-center", _ctx.checkedRisks.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none']),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createAssesmentTask && _ctx.createAssesmentTask(...args)))
            }, "Create", 2))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex != 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: _normalizeClass(["flex", (_ctx.selectedTabIndex == 0 && _ctx.risksList.length != 0) || (_ctx.selectedTabIndex == 1 && _ctx.mappedInfoForProcess.length != 0) || (_ctx.selectedTabIndex == 3 && _ctx.sortedData.length >= 0) ? 'filterButton' : 'btndisabled pointer-events-none']),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              ((_ctx.selectedTabIndex == 0 && _ctx.risksList.length != 0) || (_ctx.selectedTabIndex == 1 && _ctx.mappedInfoForProcess.length != 0) || (_ctx.selectedTabIndex == 3 && _ctx.sortedData.length >= 0) )
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6)),
              _cache[94] || (_cache[94] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Tabs, {
        value: _ctx.selectedTabIndex,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
        scrollable: "",
        class: "heightFixing pr-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_TabList, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, index) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: index,
                    value: tab.id,
                    onClick: ($event: any) => (_ctx.toggleTabs(tab))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.displayName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, index) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: index,
                  value: tab.id
                }, {
                  default: _withCtx(() => [
                    (_ctx.dataLoading == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_dots_loader)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (tab.id == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.risksList,
                                  headersData: _ctx.riskHeaders,
                                  openPopup: true,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.mappedInfoForProcess,
                                  headersData: _ctx.informationHeaders,
                                  openPopup: true,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Activity", -1)),
                                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.businessProcess.businessProcessName  || 'N/A'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_21, [
                                        _cache[96] || (_cache[96] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.businessProcess.department != undefined ? `${_ctx.businessProcess.department.label}`:'N/A'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _cache[97] || (_cache[97] = _createElementVNode("label", { class: "controllabel" }, "Activity Owner", -1)),
                                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.businessProcess.name != undefined ? `${_ctx.businessProcess.name.label}`:'N/A'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_26, [
                                        _cache[98] || (_cache[98] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.entityLabel(_ctx.businessProcess.entity)), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _cache[99] || (_cache[99] = _createElementVNode("label", { class: "controllabel" }, "Job Title", -1)),
                                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.businessProcess.role || "N/A"), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_31, [
                                        _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel" }, "Criticality", -1)),
                                        (_ctx.businessProcess.criticality.value)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["rounded h-5 w-28 mt-2 mb-3 flex items-center justify-center", _ctx.colorLabelBg(_ctx.businessProcess.criticality.value)])
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.businessProcess.criticality.value)])
                                              }, _toDisplayString(_ctx.getCriticalityLabel(_ctx.businessProcess.criticality.value)), 3)
                                            ], 2))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _cache[101] || (_cache[101] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.businessProcess.description || 'N/A'), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_ctx.discovery == false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("table", null, [
                                          _createElementVNode("thead", null, [
                                            _createElementVNode("th", _hoisted_38, [
                                              _createElementVNode("div", _hoisted_39, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectAllOption) = $event)),
                                                  class: "checkbox cursor-pointer",
                                                  disabled: _ctx.riskAssesmentList.length == 0,
                                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllOptions($event)))
                                                }, null, 40, _hoisted_40), [
                                                  [_vModelCheckbox, _ctx.selectAllOption]
                                                ])
                                              ])
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discoverHeaders, (column) => {
                                              return (_openBlock(), _createElementBlock("th", {
                                                scope: "col",
                                                onClick: ($event: any) => (_ctx.sort(column)),
                                                key: column,
                                                class: _normalizeClass([_ctx.getColumnHeadWidth(column), "bg-white capitalize"])
                                              }, [
                                                (column=='severity')
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: _normalizeClass(["flex items-center justify-center", _ctx.getFilterWidth(column)])
                                                    }, [
                                                      _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(column)), 1),
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                                      }, null, 2)
                                                    ], 2))
                                                  : (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      class: _normalizeClass(["flex items-center", _ctx.getFilterWidth(column)])
                                                    }, [
                                                      _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(column)), 1),
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                                      }, null, 2)
                                                    ], 2))
                                              ], 10, _hoisted_41))
                                            }), 128)),
                                            (_ctx.showFilters)
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                                  _cache[105] || (_cache[105] = _createElementVNode("td", null, null, -1)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discoverHeaders, (name, index) => {
                                                    return (_openBlock(), _createElementBlock("td", {
                                                      class: "bg-white",
                                                      key: index
                                                    }, [
                                                      (name == 'severity')
                                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                            key: 0,
                                                            class: _normalizeClass(_ctx.assesmentFilters[name] == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                                            "onUpdate:modelValue": ($event: any) => ((_ctx.assesmentFilters[name]) = $event)
                                                          }, [
                                                            _cache[102] || (_cache[102] = _createElementVNode("option", {
                                                              value: "",
                                                              selected: "",
                                                              disabled: "",
                                                              hidden: ""
                                                            }, "Select", -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSeverity, (pair) => {
                                                              return (_openBlock(), _createElementBlock("option", {
                                                                class: "optionColors",
                                                                key: pair,
                                                                value: pair.value
                                                              }, _toDisplayString(pair.key), 9, _hoisted_44))
                                                            }), 128))
                                                          ], 10, _hoisted_43)), [
                                                            [_vModelSelect, _ctx.assesmentFilters[name]]
                                                          ])
                                                        : (name == 'likelihood')
                                                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                              key: 1,
                                                              class: _normalizeClass(["widthForSelect", _ctx.assesmentFilters[name] == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                              "onUpdate:modelValue": ($event: any) => ((_ctx.assesmentFilters[name]) = $event)
                                                            }, [
                                                              _cache[103] || (_cache[103] = _createElementVNode("option", {
                                                                value: "",
                                                                selected: "",
                                                                disabled: "",
                                                                hidden: ""
                                                              }, "Select", -1)),
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLikelihood, (pair) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                  class: "optionColors",
                                                                  key: pair,
                                                                  value: pair.value
                                                                }, _toDisplayString(pair.key), 9, _hoisted_46))
                                                              }), 128))
                                                            ], 10, _hoisted_45)), [
                                                              [_vModelSelect, _ctx.assesmentFilters[name]]
                                                            ])
                                                          : (name == 'overallImpact')
                                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                key: 2,
                                                                class: _normalizeClass(["widthForSelect", _ctx.assesmentFilters[name] == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.assesmentFilters[name]) = $event)
                                                              }, [
                                                                _cache[104] || (_cache[104] = _createElementVNode("option", {
                                                                  value: "",
                                                                  selected: "",
                                                                  disabled: "",
                                                                  hidden: ""
                                                                }, "Select", -1)),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOverAllImpact, (pair) => {
                                                                  return (_openBlock(), _createElementBlock("option", {
                                                                    class: "optionColors",
                                                                    key: pair,
                                                                    value: pair.value
                                                                  }, _toDisplayString(pair.key), 9, _hoisted_48))
                                                                }), 128))
                                                              ], 10, _hoisted_47)), [
                                                                [_vModelSelect, _ctx.assesmentFilters[name]]
                                                              ])
                                                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                key: 3,
                                                                type: "text",
                                                                class: "searchForInputBoxStyling filter-font-size",
                                                                placeholder: "Search",
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.assesmentFilters[name]) = $event)
                                                              }, null, 8, _hoisted_49)), [
                                                                [_vModelText, _ctx.assesmentFilters[name]]
                                                              ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.sortedData.length == 0)
                                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_50, [
                                                _createElementVNode("tr", _hoisted_51, [
                                                  _createElementVNode("td", {
                                                    class: "relative h-10",
                                                    colspan: _ctx.discoverHeaders.length+1
                                                  }, _cache[106] || (_cache[106] = [
                                                    _createElementVNode("div", { class: "flex justify-center" }, [
                                                      _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                    ], -1)
                                                  ]), 8, _hoisted_52)
                                                ])
                                              ]))
                                            : (_openBlock(), _createElementBlock("tbody", _hoisted_53, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (riskObj, indexx) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: riskObj,
                                                    class: "cursor-pointer rowHeight",
                                                    onClick: ($event: any) => (_ctx.openRisk(riskObj))
                                                  }, [
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        class: "checkbox",
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedRisks) = $event)),
                                                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeInRiskAssesmentTd && _ctx.changeInRiskAssesmentTd(...args))),
                                                        value: riskObj._id
                                                      }, null, 40, _hoisted_55), [
                                                        [_vModelCheckbox, _ctx.checkedRisks]
                                                      ])
                                                    ]),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discoverHeaders, (column) => {
                                                      return (_openBlock(), _createElementBlock("td", {
                                                        onMouseout: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doFalse())),
                                                        key: column,
                                                        class: "cursor-pointer relative"
                                                      }, [
                                                        (column == 'severity')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                              _createElementVNode("div", _hoisted_57, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded-full w-5 h-5", _ctx.colorPropBg('border', riskObj.severity)]),
                                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, indexx, riskObj, 'circleButton'))
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', riskObj.severity)])
                                                                  }, null, 2)
                                                                ], 42, _hoisted_58)
                                                              ])
                                                            ]))
                                                          : (column == 'likelihood')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorRiskBg(riskObj[column])])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorRiskText(riskObj[column]))
                                                                  }, _toDisplayString(_ctx.dbLikelihood.find((l) => {
                                                                        return l.value == riskObj[column];
                                                                    })?.key), 3)
                                                                ], 2)
                                                              ]))
                                                            : (column == 'overallImpact')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorRiskBg(riskObj[column])])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(_ctx.colorRiskText(riskObj[column]))
                                                                    }, _toDisplayString(_ctx.dbOverAllImpact.find((l) => {
                                                                        return l.value == riskObj[column];
                                                                    })?.key), 3)
                                                                  ], 2)
                                                                ]))
                                                              : (_openBlock(), _createElementBlock("div", {
                                                                  key: 3,
                                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, indexx, riskObj, 'text'))
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_62, [
                                                                    _createElementVNode("div", {
                                                                      onMousemove: ($event: any) => (_ctx.toolTip(column, $event, indexx, riskObj, 'text'))
                                                                    }, _toDisplayString(riskObj[column]), 41, _hoisted_63)
                                                                  ])
                                                                ], 40, _hoisted_61))
                                                      ], 32))
                                                    }), 128))
                                                  ], 8, _hoisted_54))
                                                }), 128))
                                              ]))
                                        ])
                                      ]),
                                      (_ctx.sortedData.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            _createVNode(_component_pagination, {
                                              dynamicPagination: _ctx.dynamicPagination,
                                              onCurrentPageUpdate: _ctx.paginationUpdations,
                                              sortedData: _ctx.sortedData
                                            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (_ctx.openRiskPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.openRiskPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_66, [
              _cache[108] || (_cache[108] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCloseBtnRisk()))
              }, _cache[107] || (_cache[107] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _cache[110] || (_cache[110] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': (_ctx.v$.riskThreatData.risk.$error||_ctx.displayErrorMessageOfRisk)
                                                }]),
                                    placeholder: "Risk",
                                    onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.restrictCharacters('Risk'))),
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.riskThreatData.risk) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.risk,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.risk.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                        (_ctx.v$.riskThreatData.risk.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfRisk == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, _cache[109] || (_cache[109] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.riskThreatData.risk||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", null, [
                              _cache[112] || (_cache[112] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                              (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.riskThreatData.riskCategory,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.riskThreatData.riskCategory) = $event)),
                                      suggestions: _ctx.searchRiskCategoryList,
                                      onComplete: _ctx.asyncRiskCategoryDataFind,
                                      onItemSelect: _ctx.selectedRiskCategoryOption,
                                      placeholder: "Risk Category",
                                      field: "label",
                                      class: _normalizeClass(["w-full", {
                                                            'p-invalid': _ctx.v$.riskThreatData.riskCategory.$error,
                                                            'has-options': _ctx.searchRiskCategoryList && _ctx.searchRiskCategoryList.length > 0,
                                                            'no-options': !_ctx.searchRiskCategoryList.length && _ctx.searchValue !== '',
                                                        }])
                                    }, {
                                      empty: _withCtx(() => _cache[111] || (_cache[111] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"]),
                                    (_ctx.v$.riskThreatData.riskCategory.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                          (_ctx.v$.riskThreatData.riskCategory.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_ctx.riskThreatData.riskCategory||'N/A'), 1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _cache[114] || (_cache[114] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.riskOwner,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.riskThreatData.riskOwner) = $event)),
                                    suggestions: _ctx.userOptions,
                                    onComplete: _ctx.asyncFind,
                                    optionLabel: "label",
                                    optionValue: "value",
                                    forceSelection: "",
                                    placeholder: "Risk Owner",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.riskThreatData.riskOwner.$error,
                                                        'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                        'no-options': !_ctx.userOptions.length && _ctx.searchValue !== '',
                                                    }])
                                  }, {
                                    empty: _withCtx(() => _cache[113] || (_cache[113] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                  (_ctx.v$.riskThreatData.riskOwner.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                        (_ctx.v$.riskThreatData.riskOwner.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_ctx.riskThreatData.riskOwner?.label||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _cache[116] || (_cache[116] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Threat", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': (_ctx.v$.riskThreatData.threatEvent.$error||_ctx.displayErrorMessageOfThreat)
                                                }]),
                                    placeholder: "Threat",
                                    onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.restrictCharacters('Threat'))),
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.riskThreatData.threatEvent) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.threatEvent,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.threatEvent.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                        (_ctx.v$.riskThreatData.threatEvent.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfThreat == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, _cache[115] || (_cache[115] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.riskThreatData.threatEvent||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _cache[118] || (_cache[118] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.threatSource,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.riskThreatData.threatSource) = $event)),
                                    suggestions: _ctx.searchThreatSourceList,
                                    onComplete: _ctx.asyncthreatSourceDataFind,
                                    onItemSelect: _ctx.selectedThreatSourceOption,
                                    placeholder: "Threat Source",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                            'has-options': _ctx.searchThreatSourceList && _ctx.searchThreatSourceList.length > 0,
                                                            'no-options': !_ctx.searchThreatSourceList.length && _ctx.searchValue !== '',
                                                        }])
                                  }, {
                                    empty: _withCtx(() => _cache[117] || (_cache[117] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Source Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.riskThreatData.threatSource||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.threatCategory,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.riskThreatData.threatCategory) = $event)),
                                    suggestions: _ctx.searchThreatCategoryList,
                                    onComplete: _ctx.asyncthreatCategoryDataFind,
                                    onItemSelect: _ctx.selectedOption,
                                    placeholder: "Threat Category",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                    'has-options': _ctx.searchThreatCategoryList && _ctx.searchThreatCategoryList.length > 0,
                                                    'no-options': !_ctx.searchThreatCategoryList.length && _ctx.searchValue !== '',
                                                }])
                                  }, {
                                    empty: _withCtx(() => _cache[119] || (_cache[119] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_ctx.riskThreatData.threatCategory||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_104, [
                          _createElementVNode("div", _hoisted_105, [
                            _cache[122] || (_cache[122] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Vulnerability", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability
                                                }]),
                                    placeholder: "Vulnerability",
                                    onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.restrictCharacters('Vulnerability'))),
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.riskThreatData.vulnerability) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.vulnerability,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.vulnerability.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                        (_ctx.v$.riskThreatData.vulnerability.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_108, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfVulnerability == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, _cache[121] || (_cache[121] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(_ctx.riskThreatData.vulnerability||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _cache[124] || (_cache[124] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk Assessment", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.riskAssessment.$error||_ctx.displayErrorMessageOfAssessment
                                                }]),
                                    placeholder: "Risk Assessment",
                                    onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.restrictCharacters('Assessment'))),
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.riskThreatData.riskAssessment) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.riskAssessment,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.riskAssessment.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                        (_ctx.v$.riskThreatData.riskAssessment.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_115, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfAssessment == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_116, _cache[123] || (_cache[123] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(_ctx.riskThreatData.riskAssessment||'N/A'), 1))
                          ])
                        ]),
                        _cache[134] || (_cache[134] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                        _cache[135] || (_cache[135] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, [
                            _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.business,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.riskThreatData.business) = $event)),
                                    options: _ctx.dbBussiness,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.business !== ''

                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.business.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                        (_ctx.v$.riskThreatData.business.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_122, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0  && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_123, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.business,1) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.business,1)||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_125, [
                            _cache[126] || (_cache[126] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.financial,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.riskThreatData.financial) = $event)),
                                    options: _ctx.dbFinancial,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.financial.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.financial === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.financial !== ''

                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.financial.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                        (_ctx.v$.riskThreatData.financial.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_128, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_129, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.financial,2) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.financial,2)||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("div", _hoisted_132, [
                            _cache[127] || (_cache[127] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.operations,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.riskThreatData.operations) = $event)),
                                    options: _ctx.dbOperations,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.operations.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations !== ''

                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.operations.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                        (_ctx.v$.riskThreatData.operations.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_135, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_136, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.operations,3) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_137, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.operations,3)||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_138, [
                            _cache[128] || (_cache[128] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.legal,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.riskThreatData.legal) = $event)),
                                    options: _ctx.dbLegal,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.legal.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal !== ''

                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.legal.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                        (_ctx.v$.riskThreatData.legal.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_142, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.legal,4) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_143, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.legal,4)||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_144, [
                          _cache[129] || (_cache[129] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskThreatData.overallImpact,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.riskThreatData.overallImpact) = $event)),
                                  options: _ctx.dbOverAllImpact,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_146, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.overallImpact,6)||'N/A'), 1))
                        ]),
                        _cache[136] || (_cache[136] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                        _cache[137] || (_cache[137] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("div", _hoisted_148, [
                            _cache[130] || (_cache[130] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.likelihood,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.riskThreatData.likelihood) = $event)),
                                    options: _ctx.dbLikelihood,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.likelihood.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood !== ''

                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.likelihood.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                        (_ctx.v$.riskThreatData.likelihood.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_151, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.likelihood,5) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.likelihood,5)||'N/A'), 1))
                          ])
                        ]),
                        (_ctx.addingRisk!=true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                              _cache[132] || (_cache[132] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                              _cache[133] || (_cache[133] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                              _createElementVNode("div", _hoisted_155, [
                                _cache[131] || (_cache[131] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskThreatData.severity,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.riskThreatData.severity) = $event)),
                                  options: _ctx.dbSeverity,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                    _cache[138] || (_cache[138] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("button", {
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-2 gap-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onCancelRiskData()))
                      }, "Reset", 10, _hoisted_158),
                      (_ctx.addingRisk)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.riskThreatData)))
                          }, "Save", 10, _hoisted_159))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.riskThreatData)))
                          }, "Update", 10, _hoisted_160))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.openRiskInformation)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.openRiskInformation
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_161, [
              _cache[140] || (_cache[140] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onCloseBtnRisk('close')))
              }, _cache[139] || (_cache[139] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("div", _hoisted_165, [
                    _createElementVNode("div", _hoisted_166, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_167, [
                          _cache[141] || (_cache[141] = _createElementVNode("label", { class: "controllabel" }, "Risk", -1)),
                          _createElementVNode("div", _hoisted_168, _toDisplayString(_ctx.riskThreatData.risk  != undefined ? _ctx.riskThreatData.risk : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _cache[142] || (_cache[142] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                          _createElementVNode("div", _hoisted_172, _toDisplayString(_ctx.riskThreatData.riskCategory  != undefined ? _ctx.riskThreatData.riskCategory : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_173, [
                          _cache[143] || (_cache[143] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                          _createElementVNode("div", _hoisted_174, _toDisplayString(_ctx.riskThreatData.riskOwner  != undefined ? _ctx.riskThreatData.riskOwner : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_175, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_176, [
                          _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Threat", -1)),
                          _createElementVNode("div", _hoisted_177, _toDisplayString(_ctx.riskThreatData.threatEvent  != undefined ? _ctx.riskThreatData.threatEvent : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("div", _hoisted_179, [
                        _createElementVNode("div", _hoisted_180, [
                          _cache[145] || (_cache[145] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                          _createElementVNode("div", _hoisted_181, _toDisplayString(_ctx.riskThreatData.threatSource  != undefined ? _ctx.riskThreatData.threatSource : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_182, [
                          _cache[146] || (_cache[146] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                          _createElementVNode("div", _hoisted_183, _toDisplayString(_ctx.riskThreatData.threatCategory  != undefined ? _ctx.riskThreatData.threatCategory : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_184, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_185, [
                          _cache[147] || (_cache[147] = _createElementVNode("label", { class: "controllabel" }, "Vulnerability", -1)),
                          _createElementVNode("div", _hoisted_186, _toDisplayString(_ctx.riskThreatData.vulnerability  != undefined ? _ctx.riskThreatData.vulnerability : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _cache[154] || (_cache[154] = _createElementVNode("h1", { class: "upperspacing" }, "Impact Analysis", -1)),
                    _cache[155] || (_cache[155] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_187, [
                      _createElementVNode("div", _hoisted_188, [
                        _createElementVNode("div", _hoisted_189, [
                          _cache[148] || (_cache[148] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                          _createElementVNode("div", _hoisted_190, _toDisplayString(_ctx.riskThreatData.business  != undefined ? _ctx.dbOperations.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_191, [
                          _cache[149] || (_cache[149] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                          _createElementVNode("div", _hoisted_192, _toDisplayString(_ctx.riskThreatData.financial  != undefined ?  _ctx.dbFinancial.find(a=>a.value==_ctx.riskThreatData.business)?.key  : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_193, [
                      _createElementVNode("div", _hoisted_194, [
                        _createElementVNode("div", _hoisted_195, [
                          _cache[150] || (_cache[150] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                          _createElementVNode("div", _hoisted_196, _toDisplayString(_ctx.riskThreatData.operations  != undefined ? _ctx.dbOperations.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_197, [
                          _cache[151] || (_cache[151] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                          _createElementVNode("div", _hoisted_198, _toDisplayString(_ctx.riskThreatData.legal  != undefined ? _ctx.dbLegal.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _cache[156] || (_cache[156] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Analysis", -1)),
                    _cache[157] || (_cache[157] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_199, [
                      _createElementVNode("div", _hoisted_200, [
                        _createElementVNode("div", _hoisted_201, [
                          _cache[152] || (_cache[152] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                          _createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.riskThreatData.likelihood  != undefined ? _ctx.dbLikelihood.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_203, [
                          _cache[153] || (_cache[153] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          _createElementVNode("div", _hoisted_204, _toDisplayString(_ctx.riskThreatData.overallImpact  != undefined ? _ctx.dbOverAllImpact.find(a=>a.value==_ctx.riskThreatData.overallImpact)?.key : 'N/A'), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[158] || (_cache[158] = _createElementVNode("div", null, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showInfoPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showInfoPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_205, [
              _cache[160] || (_cache[160] = _createElementVNode("h1", null, "Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onCloseInformation()))
              }, _cache[159] || (_cache[159] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "flex flex-col h-full",
              disabled: _ctx.information._id
            }, [
              _createElementVNode("div", _hoisted_207, [
                _createElementVNode("div", _hoisted_208, [
                  _createElementVNode("div", _hoisted_209, [
                    _createElementVNode("div", _hoisted_210, [
                      _createElementVNode("div", _hoisted_211, [
                        (_ctx.information.information != '' && !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                              _cache[161] || (_cache[161] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                              _createElementVNode("div", _hoisted_213, _toDisplayString(_ctx.information.informationCategory), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_214, [
                              _cache[163] || (_cache[163] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.information.informationCategory,
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.information.informationCategory) = $event)),
                                suggestions: _ctx.filteredCategories,
                                onComplete: _ctx.searchCategory,
                                placeholder: "Information Category",
                                field: "label",
                                class: _normalizeClass(["w-full", {
                                            'is-invalidmultiselect': _ctx.v$.information.informationCategory.$error,
                                            'has-options': _ctx.filteredCategories && _ctx.filteredCategories.length > 0,
                                            'no-options':  !_ctx.filteredCategories.length,
                                        }])
                              }, {
                                empty: _withCtx(() => _cache[162] || (_cache[162] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                              (_ctx.v$.information.informationCategory.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                                    (_ctx.v$.information.informationCategory.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_216, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      (_ctx.information.information != '' && !_ctx.addInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
                            _cache[164] || (_cache[164] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                            _createElementVNode("div", _hoisted_218, _toDisplayString(_ctx.information.information), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_219, [
                            _cache[166] || (_cache[166] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.information.information,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.information.information) = $event)),
                              suggestions: _ctx.filteredInformation,
                              onComplete: _ctx.searchInformation,
                              disabled: !_ctx.addInfo || _ctx.information.informationCategory === '',
                              placeholder: "Information",
                              field: "label",
                              class: _normalizeClass(["w-full", {
                                            'is-invalidmultiselect': _ctx.v$.information.information.$error,
                                            'has-options': _ctx.filteredInformation && _ctx.filteredInformation.length > 0,
                                            'no-options':  !_ctx.filteredInformation.length,
                                        }])
                            }, {
                              empty: _withCtx(() => _cache[165] || (_cache[165] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Information Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"]),
                            (_ctx.v$.information.information.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                  (_ctx.v$.information.information.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_221, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])),
                      _createElementVNode("div", _hoisted_222, [
                        (_ctx.information.information != '' && !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                              _cache[167] || (_cache[167] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                              _createElementVNode("div", _hoisted_224, _toDisplayString(_ctx.information.informationOwner.label), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_225, [
                              _cache[169] || (_cache[169] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.informationOwner,
                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.information.informationOwner) = $event)),
                                options: _ctx.optionsUserArray,
                                optionLabel: "label",
                                optionValue: "value",
                                placeholder: "Information Owner",
                                disabled: "",
                                class: "custom-multiselect userSelect w-full"
                              }, {
                                emptyfilter: _withCtx(() => _cache[168] || (_cache[168] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Options Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options"])
                            ])),
                        (_ctx.information.confidentiality != '' || !_ctx.addInfo || !_ctx.addCIAInfo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(["w-6/12", !_ctx.information._id ? 'leftspacing': ''])
                            }, [
                              _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbConfidentiality, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.confidentiality == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                        _createElementVNode("div", _hoisted_227, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_228, [
                              _cache[171] || (_cache[171] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.confidentiality,
                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.information.confidentiality) = $event)),
                                options: _ctx.dbConfidentiality,
                                disabled: "",
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Confidentiality",
                                onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_229, [
                        (_ctx.information.integrity != '' || !_ctx.addInfo || !_ctx.addCIAInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                              _cache[172] || (_cache[172] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbIntegrity, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.integrity == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                                        _createElementVNode("div", _hoisted_232, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_233, [
                              _cache[173] || (_cache[173] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.integrity,
                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.information.integrity) = $event)),
                                options: _ctx.dbConfidentiality,
                                disabled: "",
                                optionLabel: "value",
                                optionValue: "key",
                                placeholder: "Integrity",
                                onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ])),
                        (_ctx.information.availability != '' || !_ctx.addInfo || !_ctx.addCIAInfo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(["w-6/12", _ctx.information._id ? '' : 'leftspacing'])
                            }, [
                              _cache[174] || (_cache[174] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbAvailability, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.availability == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                        _createElementVNode("div", _hoisted_235, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_236, [
                              _cache[175] || (_cache[175] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.availability,
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.information.availability) = $event)),
                                options: _ctx.dbAvailability,
                                disabled: "",
                                optionLabel: "value",
                                optionValue: "key",
                                placeholder: "Integrity",
                                onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_237, [
                        (_ctx.information.classification != '' || !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                              _cache[176] || (_cache[176] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbInformationClassification, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.classification == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                        _createElementVNode("div", _hoisted_240, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_241, [
                              _cache[177] || (_cache[177] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.availability,
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.information.availability) = $event)),
                                options: _ctx.dbInformationClassification,
                                disabled: "",
                                optionLabel: "value",
                                optionValue: "key",
                                placeholder: "Classification",
                                onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.classification.$error
                                            }])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.information.classification.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                                    (_ctx.v$.information.classification.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_243, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])),
                        (_ctx.information.securityCategory != '' && !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.securityCategory == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                                        _cache[178] || (_cache[178] = _createElementVNode("label", { class: "controllabel" }, "Security Category", -1)),
                                        _createElementVNode("div", _hoisted_246, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.addInformationObj.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_247))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addInformationObj, (info, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-row justify-between",
                        key: info
                      }, [
                        (_ctx.addInformationObj.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                              _createElementVNode("div", _hoisted_249, [
                                _createElementVNode("ul", null, [
                                  _createElementVNode("li", _hoisted_250, _toDisplayString(info.information), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_251, [
                          _createElementVNode("button", {
                            class: "float-right",
                            onClick: ($event: any) => (_ctx.onInfoDelete(index))
                          }, _cache[179] || (_cache[179] = [
                            _createElementVNode("img", {
                              src: _imports_3,
                              class: "h-5 w-5 cursor-pointer"
                            }, null, -1)
                          ]), 8, _hoisted_252)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.addInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                    _cache[180] || (_cache[180] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_254, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatusInfo ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.onCancelBtnInfo()))
                      }, "Reset", 2),
                      _createElementVNode("button", {
                        onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.addInformationToObject())),
                        class: _normalizeClass(_ctx.disableStatusInfo ? 'btnprimary' : 'btndisabled pointer-events-none')
                      }, "Add", 2)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_255, [
                    _cache[181] || (_cache[181] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    (_ctx.addInformationObj.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                          _createElementVNode("button", {
                            class: "btnprimary mr-1.5",
                            onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.onResetBtnInfo(_ctx.information)))
                          }, "Reset"),
                          _createElementVNode("button", {
                            class: "btnprimary",
                            onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.saveInformation()))
                          }, "Save")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ], 8, _hoisted_206)
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPriorityPopUp)
      ? (_openBlock(), _createBlock(_component_popup, { key: 3 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_257, [
              _cache[183] || (_cache[183] = _createElementVNode("h1", null, "Risk Prioritize", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.closePriorityPopup()))
              }, _cache[182] || (_cache[182] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_258, [
              _createElementVNode("div", _hoisted_259, [
                _createElementVNode("div", _hoisted_260, [
                  _createElementVNode("div", _hoisted_261, [
                    _createElementVNode("div", _hoisted_262, [
                      _cache[184] || (_cache[184] = _createElementVNode("label", {
                        class: "controllabel font-normal text-sm mb-1",
                        for: "vulnerability"
                      }, "Risk Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.riskPriorityShow.risk) = $event)),
                        disabled: "",
                        placeholder: "Name of the Risk",
                        id: "id",
                        class: _normalizeClass(["disabledinputboxstyling", {
                                'is-invalid': _ctx.v$.riskPriorityShow.risk.$error
                            }])
                      }, null, 2), [
                        [
                          _vModelText,
                          _ctx.riskPriorityShow.risk,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.riskPriorityShow.risk.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_263, [
                            (_ctx.v$.riskPriorityShow.risk.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_264, "Risk name is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_265, [
                      _cache[185] || (_cache[185] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                      _createVNode(_component_Select, {
                        modelValue: _ctx.riskPriorityShow.priority,
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.riskPriorityShow.priority) = $event)),
                        options: _ctx.dbPriority,
                        optionLabel: "key",
                        optionValue: "value",
                        class: "custom-multiselect w-full"
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    (_ctx.v$.riskPriorityShow.priority.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                          (_ctx.v$.riskPriorityShow.priority.required.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_267, "Please change priority"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (this.riskPriorityShow.priority !== this.priorityDummy.priority)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                          _createElementVNode("div", _hoisted_269, [
                            _createElementVNode("div", _hoisted_270, [
                              _cache[186] || (_cache[186] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Justification", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling", {
                                        'is-invalid': _ctx.v$.riskPriorityShow.justification.$error
                                    }]),
                                placeholder: "Justification",
                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.riskPriorityShow.justification) = $event))
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.riskPriorityShow.justification,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ]),
                          (_ctx.v$.riskPriorityShow.justification.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                                (_ctx.v$.riskPriorityShow.justification.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_272, "Justification is required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[187] || (_cache[187] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_273, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.cancelPriorityBtn()))
                  }, "Reset", 10, _hoisted_274),
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.addOrUpdatePriority())),
                    class: _normalizeClass(JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none')
                  }, "Save", 10, _hoisted_275)
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.applyPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          class: "applyPopup",
          popUp: _ctx.applyPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_276, [
              _createElementVNode("div", _hoisted_277, [
                _createElementVNode("div", _hoisted_278, [
                  _createElementVNode("div", _hoisted_279, [
                    (_ctx.thisScreen == 'Acceptance')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_280, "Risk Accept"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'reset')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_281, "Risk Reset"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'deactive')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_282, "Risk Invalid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Avoid')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_283, "Risk Avoid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Transfer')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_284, "Risk Transfer"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Monitered')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_285, "Risk Moniter"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onClosebtnAction()))
                    }, _cache[188] || (_cache[188] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[217] || (_cache[217] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_286, [
                      _createElementVNode("div", _hoisted_287, [
                        _createElementVNode("div", _hoisted_288, [
                          _createElementVNode("div", _hoisted_289, [
                            _cache[189] || (_cache[189] = _createElementVNode("label", { class: "controllabel" }, "Activity", -1)),
                            _createElementVNode("div", _hoisted_290, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainProcess, (process) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: process.value,
                                  class: "mr-2 mb-2 px-2 py-1 bg-primary text-white rounded"
                                }, _toDisplayString(_ctx.mappedProcessOptions.find(option => option.value === process)?.label || "Unknown"), 1))
                              }), 128)),
                              (_ctx.mainProcess.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_291, "No processes selected"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _cache[216] || (_cache[216] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey upperspacing" }, null, -1)),
                          _createElementVNode("div", _hoisted_292, [
                            (_ctx.thisScreen == 'Acceptance')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_293, "Treatment Summary for Accepting Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'reset')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_294, "Treatment Summary for Reset Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'deactive')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_295, "Treatment Summary for Invalid Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Avoid')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_296, "Treatment Summary for Avoid Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Transfer')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_297, "Treatment Summary for Transfer Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Monitered')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_298, "Treatment Summary for Monitered Risk"))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text",
                              class: _normalizeClass(["inputboxstyling h-20 max-h-48", {
                                                    'is-invalid': (_ctx.v$.applyObj.comments.$error)
                                                }]),
                              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.applyObj.comments) = $event)),
                              placeholder: "Treatment Summary"
                            }, "                                            ", 2), [
                              [
                                _vModelText,
                                _ctx.applyObj.comments,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.applyObj.comments.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_299, [
                                  (_ctx.v$.applyObj.comments.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_300, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.thisScreen!='Avoid' && _ctx.thisScreen!='reset' && _ctx.thisScreen!='deactive' && (_ctx.thisScreen!='Monitered' && _ctx.residualData.statusCode!=10425))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_301, [
                                _cache[197] || (_cache[197] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                                _cache[198] || (_cache[198] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                _createElementVNode("div", _hoisted_302, [
                                  _createElementVNode("div", _hoisted_303, [
                                    _cache[190] || (_cache[190] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.business,
                                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.residualData.business) = $event)),
                                      options: _ctx.dbBussiness,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      onChange: _cache[64] || (_cache[64] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                            'is-invalid': _ctx.v$.residualData.business.$error,
                                                            'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                        }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.business.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_304, [
                                          (_ctx.v$.residualData.business.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_305, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_306, [
                                    _cache[191] || (_cache[191] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.financial,
                                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.residualData.financial) = $event)),
                                      options: _ctx.dbFinancial,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      onChange: _cache[66] || (_cache[66] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                            'is-invalid': _ctx.v$.residualData.business.$error,
                                                            'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                        }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.financial.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_307, [
                                          (_ctx.v$.residualData.financial.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_308, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_309, [
                                  _createElementVNode("div", _hoisted_310, [
                                    _cache[192] || (_cache[192] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.operations,
                                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.residualData.operations) = $event)),
                                      options: _ctx.dbOperations,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      onChange: _cache[68] || (_cache[68] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.operations !== ''
                                                        }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.operations.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_311, [
                                          (_ctx.v$.residualData.operations.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_312, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_313, [
                                    _cache[193] || (_cache[193] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.legal,
                                      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.residualData.legal) = $event)),
                                      options: _ctx.dbLegal,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      onChange: _cache[70] || (_cache[70] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.legal !== ''
                                                        }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.legal.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                          (_ctx.v$.residualData.legal.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_315, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_316, [
                                  _cache[194] || (_cache[194] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.residualData.overallImpact,
                                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.residualData.overallImpact) = $event)),
                                    options: _ctx.dbOverAllImpact,
                                    disabled: "",
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    class: "custom-multiselect w-full"
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _cache[199] || (_cache[199] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                                _cache[200] || (_cache[200] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                _createElementVNode("div", _hoisted_317, [
                                  _createElementVNode("div", _hoisted_318, [
                                    _cache[195] || (_cache[195] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.likelihood,
                                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.residualData.likelihood) = $event)),
                                      options: _ctx.dbLikelihood,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      placeholder: "Please select one",
                                      onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.likelihood !== ''
                                                        }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.likelihood.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                                          (_ctx.v$.residualData.likelihood.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_320, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _cache[201] || (_cache[201] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                                _cache[202] || (_cache[202] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                _createElementVNode("div", _hoisted_321, [
                                  _cache[196] || (_cache[196] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.residualData.severity,
                                    "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.residualData.severity) = $event)),
                                    options: _ctx.dbSeverity,
                                    disabled: "",
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    class: "custom-multiselect w-full"
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ]))
                            : ((_ctx.thisScreen=='Monitered' && _ctx.residualData.statusCode==10425))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_322, [
                                  _cache[210] || (_cache[210] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                                  _cache[211] || (_cache[211] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_323, [
                                    _createElementVNode("div", _hoisted_324, [
                                      _cache[203] || (_cache[203] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.business,
                                        "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.residualData.business) = $event)),
                                        options: _ctx.dbBussiness,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        onChange: _cache[76] || (_cache[76] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                            'is-invalid': _ctx.v$.residualData.business.$error,
                                                            'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                        }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.business.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
                                            (_ctx.v$.residualData.business.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_326, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_327, [
                                      _cache[204] || (_cache[204] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.financial,
                                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.residualData.financial) = $event)),
                                        options: _ctx.dbFinancial,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[78] || (_cache[78] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                            'is-invalid': _ctx.v$.residualData.business.$error,
                                                            'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                        }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.financial.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_328, [
                                            (_ctx.v$.residualData.financial.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_329, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_330, [
                                    _createElementVNode("div", _hoisted_331, [
                                      _cache[205] || (_cache[205] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.operations,
                                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.residualData.operations) = $event)),
                                        options: _ctx.dbOperations,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[80] || (_cache[80] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.operations !== ''
                                                        }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.operations.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_332, [
                                            (_ctx.v$.residualData.operations.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_333, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_334, [
                                      _cache[206] || (_cache[206] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.legal,
                                        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.residualData.legal) = $event)),
                                        options: _ctx.dbLegal,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        onChange: _cache[82] || (_cache[82] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.legal !== ''
                                                        }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.legal.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_335, [
                                            (_ctx.v$.residualData.legal.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_336, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_337, [
                                    _cache[207] || (_cache[207] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.overallImpact,
                                      "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.residualData.overallImpact) = $event)),
                                      options: _ctx.dbOverAllImpact,
                                      disabled: "",
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: "custom-multiselect w-full"
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _cache[212] || (_cache[212] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                                  _cache[213] || (_cache[213] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_338, [
                                    _createElementVNode("div", _hoisted_339, [
                                      _cache[208] || (_cache[208] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.likelihood,
                                        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.residualData.likelihood) = $event)),
                                        options: _ctx.dbLikelihood,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        placeholder: "Please select one",
                                        onChange: _cache[85] || (_cache[85] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.likelihood !== ''
                                                        }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.likelihood.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                            (_ctx.v$.residualData.likelihood.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_341, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _cache[214] || (_cache[214] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                                  _cache[215] || (_cache[215] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_342, [
                                    _cache[209] || (_cache[209] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.severity,
                                      "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.residualData.severity) = $event)),
                                      options: _ctx.dbSeverity,
                                      disabled: "",
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: "custom-multiselect w-full"
                                    }, null, 8, ["modelValue", "options"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[218] || (_cache[218] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_343, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.cancelAceeptResetBtn())),
                    class: _normalizeClass([_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData))  ? 'btndisabled pointer-events-none' : 'btnprimary', "mr-3"])
                  }, "Reset", 10, _hoisted_344),
                  (_ctx.thisScreen == 'Acceptance')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10403)))
                      }, "Apply", 10, _hoisted_345))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'Avoid')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                        onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10419)))
                      }, "Apply", 10, _hoisted_346))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'Transfer')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'),
                        onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10424)))
                      }, "Apply", 10, _hoisted_347))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'Monitered')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'),
                        onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10425)))
                      }, "Apply", 10, _hoisted_348))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'reset')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10407)))
                      }, "Apply", 10, _hoisted_349))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'deactive')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10404)))
                      }, "Apply", 10, _hoisted_350))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}